import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import loginReducer from './slice/loginSlice';
import videoReducer from './slice/homeSlice';

export function makeStore() {
    return configureStore({
        reducer: {
            login: loginReducer,
            video: videoReducer,
        },
    });
}

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    AppState,
    unknown,
    Action<string>
>;

export default store;
